export const environment = {
  production: true,
  food_search_host: 'https://app.idoplanty.de:35001/',
  idoplanty_backend_host: 'https://app.idoplanty.de:36001/',
  wordpress_blog_url: 'https://idoplanty.de/',
  app_id: 'com.idoplanty.app',
  app_link_base: 'https://open.idoplanty.de/',
  auth_config: {
    client_id: 'idoplantyApp',
    server_host: 'https://app.idoplanty.de',
    redirect_url: 'com.idoplanty.app://callback',
    end_session_redirect_url: 'com.idoplanty.app://endsession',
    scopes: 'openid offline_access profile email foodSearchAPI userAPI IdentityServerApi',
    pkce: true
  }
};
